import React from 'react';
import { motion } from 'framer-motion';
import { Github, ExternalLink, Star, GitFork, Code2 } from 'lucide-react';
import { openSourceProjects } from '../data/siteData';

const OpenSource = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 }
  };

  const hasProjects = openSourceProjects && openSourceProjects.length > 0;

  const getTypeIcon = (type) => {
    switch (type) {
      case 'library':
        return Code2;
      case 'template':
        return GitFork;
      default:
        return Github;
    }
  };

  return (
    <section id="opensource" className="opensource-section">
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h1>Open Source & Technical Contributions</h1>
          <p>Public repositories, technical contributions, and documentation</p>
        </motion.div>

        {hasProjects ? (
          <motion.div
            className="opensource-grid"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            {openSourceProjects.map((project) => {
              const TypeIcon = getTypeIcon(project.type);
              return (
                <motion.a
                  key={project.id}
                  href={project.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="opensource-card"
                  variants={itemVariants}
                  whileHover={{ y: -5 }}
                >
                  <div className="opensource-header">
                    <TypeIcon size={20} />
                    <h2>{project.title}</h2>
                  </div>
                  <p>{project.description}</p>
                  <div className="opensource-footer">
                    {project.stars && (
                      <span className="opensource-stars">
                        <Star size={14} />
                        {project.stars}
                      </span>
                    )}
                    <span className="opensource-link">
                      View <ExternalLink size={14} />
                    </span>
                  </div>
                </motion.a>
              );
            })}
          </motion.div>
        ) : (
          <motion.div
            className="empty-state"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
          >
            <Github size={48} className="empty-state-icon" />
            <p className="empty-state-text">Open source contributions coming soon</p>
            <p className="empty-state-subtext">Public repositories and community projects will appear here.</p>
          </motion.div>
        )}
      </div>
    </section>
  );
};

export default OpenSource;
